export default "__VITE_ASSET__6087c1ad__"